import { assignModel } from '@/common/helpers/assignModel';

export enum SystemAlertType {
  Error = 1,
  Warning = 2,
  Info = 3,
}

export class SystemAlertModel {
  id!: string;
  title!: string;
  content!: string;
  priority!: SystemAlertType;
}

export class SystemAlert extends SystemAlertModel {
  constructor(model: SystemAlertModel) {
    super();

    assignModel<SystemAlertModel>(this, model);
  }
}
